import { Component, inject, ViewChild } from "@angular/core";
import { DatabaseItemsService } from "./database-items.service";
import { CreateMode, GridComponent, IGridColumn, IGridSettings, ITableSettings, UpdateMode } from "@features/grid";
import { DatabaseMenuItem } from "./database-menu-item";
import { ConfirmationService } from "primeng/api";

@Component({
    selector: "",
    templateUrl: "./database-items.component.html",
    styleUrl: "./database-items.component.scss"
})
export class DatabaseItemsComponent {
    private databaseMenuItemService = inject(DatabaseItemsService);
    private confirmationService = inject(ConfirmationService);

    @ViewChild(GridComponent) private grid: GridComponent;

    protected gridSettings = <IGridSettings>{
        dataService: this.databaseMenuItemService,
        createMode: CreateMode.Disabled,
        updateMode: UpdateMode.External,
        deletingEnabled: true,
        deleteFunc: (item: DatabaseMenuItem) => this.deleteItem(item.primaryKey),
        updateFunc: (item: DatabaseMenuItem) => {
            this.updatingItemId = item.primaryKey;
            this.isUpdatingItem = true;
        }
    };
    protected tableSettings = <ITableSettings>{
        columns: <IGridColumn[]>[
            { field: "databaseItem", header: "Item", sortable: false, editable: false },
            { field: "parentItem", header: "Parent", sortable: false }
        ]
    };
    protected isUpdatingItem: boolean;
    protected updatingItemId: string;

    protected onParentSelected() {
        this.grid?.reload();
    }

    private deleteItem(id: string) {
        this.confirmationService.confirm({
            header: "Database Menu Item",
            message: "Are you sure you want to delete this Database Menu Item?",
            accept: async () => {
                await this.databaseMenuItemService.delete(id);
                this.grid?.reload();
            }
        });
    }
}
